module.exports = __webpack_public_path__ + "img/I.43d6c6cf.jpg";